import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSlidersH, FaIdCard, FaMobileAlt, FaArrowLeft } from "react-icons/fa";
import TopNavbar from "../components/Gnavbar";
import BottomNavbar from "../components/BottomNavbar";
import SearchById from "../components/SearchById";
import AdvancedSearch from "../components/AdvanceSearch";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { hasActiveMembership } from "../utils/bureau";
import SearchByMobile from "../components/SearchByMobile";

const SearchPage = () => {
  const [activeTab, setActiveTab] = useState("criteria");
  const navigate = useNavigate();
  const bureauInfo = useSelector((state: RootState) => state.bureau.data);
  const isPaidAccount = hasActiveMembership(bureauInfo?.paymentStatus);

  // useEffect(() => {
  //   if (bureauInfo && !isPaidAccount) {
  //     navigate("/membership/plans", { replace: true });
  //   }
  // }, [bureauInfo, isPaidAccount, navigate]);

  // if (bureauInfo && !isPaidAccount) {
  //   return null;
  // }

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-emerald-50 pb-28 md:pb-0">
      <div className="hidden md:block">
        <TopNavbar />
      </div>

      {/* Page Container */}
      <div className="max-w-7xl pt-4 md:mt-10 mx-auto sm:px-6 lg:px-8 mb-24 md:mb-20">
        {/* Tabs Section */}
        <div className="bg-white sm:rounded-2xl sm:shadow-[0_18px_45px_-25px_rgba(15,23,42,0.35)] sm:border sm:border-slate-200">
          {/* Tabs Header */}
          <div className="p-4 sm:p-5 border-b border-slate-200">
            {/* Header */}
            <div className="flex items-center mb-6 block sm:hidden">
              <FaArrowLeft
                className="mr-3 text-gray-600 cursor-pointer text-xl"
                onClick={() => navigate(-1)}
              />
              <div className="flex flex-1 items-center justify-between gap-3">
                <h1 className="text-2xl font-bold text-gray-800">Search</h1>
              </div>
            </div>

            <div className="flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => setActiveTab("criteria")}
                aria-pressed={activeTab === "criteria"}
                className={`w-[calc(50%-0.375rem)] sm:w-auto inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm sm:text-base font-semibold transition-all duration-200 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2
                  ${
                    activeTab === "criteria"
                      ? "bg-emerald-600 text-white shadow-emerald-200"
                      : "bg-slate-100 text-slate-600 hover:bg-emerald-50 hover:text-emerald-700"
                  }`}
              >
                <FaSlidersH className="text-base" />
                Search by Criteria
              </button>

              <button
                type="button"
                onClick={() => setActiveTab("id")}
                aria-pressed={activeTab === "id"}
                className={`w-[calc(50%-0.375rem)] sm:w-auto inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm sm:text-base font-semibold transition-all duration-200 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2
                  ${
                    activeTab === "id"
                      ? "bg-emerald-600 text-white shadow-emerald-200"
                      : "bg-slate-100 text-slate-600 hover:bg-emerald-50 hover:text-emerald-700"
                  }`}
              >
                <FaIdCard className="text-base" />
                Search by Profile ID
              </button>

              <button
                type="button"
                onClick={() => setActiveTab("mobile")}
                aria-pressed={activeTab === "mobile"}
                className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm sm:text-base font-semibold transition-all duration-200 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2
                  ${
                    activeTab === "mobile"
                      ? "bg-emerald-600 text-white shadow-emerald-200"
                      : "bg-slate-100 text-slate-600 hover:bg-emerald-50 hover:text-emerald-700"
                  }`}
              >
                <FaMobileAlt className="text-base" />
                Search by Mobile
              </button>
            </div>
          </div>

          {/* Card Content */}
          {activeTab === "criteria" && <AdvancedSearch />}
          {activeTab === "id" && <SearchById />}
          {activeTab === "mobile" && <SearchByMobile />}
        </div>
      </div>

      <BottomNavbar />
    </div>
  );
};

export default SearchPage;
